<p class="mt-4 pb-2 font-bold text-xs">
  {{ 'outlook.entries.opportunities' | translate }}
</p>

@if (loading) {
  <maximizer-outlook-skeleton
    containerClasses="h-[120px] w-full rounded-md bg-neutral-25"
  ></maximizer-outlook-skeleton>
} @else if (!configuration.opportunity) {
  <p class="text-body pb-8">
    {{
      'outlook.summary.opportunity.emptyState'
        | translate
          : {
              label: 'outlook.entries.opportunities' | translate,
            }
    }}
  </p>
} @else {
  <div class="mt-2 text-xs space-y-2">
    <div
      class="bg-white w-full rounded border border-neutral-20 flex flex-col p-2 pl-2 mb-2 justify-around"
    >
      <div class="flex flex-row">
        <div class="flex-shrink-0">
          <span
            class="mr-1 my-auto fa-icons icon-solid icon-12 icon-dollar-sign text-neutral-70"
          ></span>
        </div>
        <div class="flex-1 flex flex-col min-w-0">
          <span
            class="font-bold my-auto text-ellipsis overflow-hidden whitespace-nowrap mb-2"
          >
            {{ configuration.opportunity.objective }}</span
          >

          <div class="flex flex-row">
            <div>
              <span class="text-neutral-90 mr-1">
                {{ 'outlook.opportunity.revenue' | translate }}:</span
              >
              <span class="text-neutral-70">{{
                configuration.opportunity.forecastRevenue | currencyFormat
              }}</span>
            </div>
            <span class="ml-auto">
              <span class="text-neutral-90 mr-1"
                >{{ 'outlook.summary.opportunity.weighted' | translate }}:
              </span>
              <span class="text-neutral-70">{{
                configuration.opportunity.stageValue | currencyFormat
              }}</span>
            </span>
          </div>

          <div class="flex flex-row items-center">
            <span class="text-neutral-90 mr-1"
              >{{ 'outlook.summary.opportunity.closingDate' | translate }}:
            </span>
            <span [class]="isOverdue ? 'text-error' : 'text-neutral-70'">{{
              configuration.opportunity.closeDate | date: 'MMMM dd, yyyy'
            }}</span>
            @if (isOverdue) {
              <span
                class="ml-1 fa-icons icon-solid icon-12 icon-clock text-error"
              ></span>
            }
          </div>

          <div
            class="text-neutral-90 mr-1 text-ellipsis overflow-hidden whitespace-nowrap"
          >
            <span class="text-neutral-90 mr-1"
              >{{ 'outlook.opportunity.owner' | translate }}:
            </span>
          </div>

          @if (configuration.opportunity.owner) {
            <div class="flex items-center gap-2">
              <span class="avatar avatar-xxs bg-inserv-10">{{
                configuration.opportunity.owner | nameInitials
              }}</span>
              <span class="text-neutral-90">{{
                configuration.opportunity.owner
              }}</span>
            </div>
          }

          <p class="text-neutral-70 line-clamp-4">
            {{ configuration.opportunity.description }}
          </p>

          <div class="flex flex-row">
            <span class="ml-auto caption text-neutral-70 pt-1">{{
              configuration.opportunity.lastModifyDate
                | date: outlookStore.fullDateTimeFormat()
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <span class="text-neutral-70">
      {{ configuration.opportunitiesAmount }}
      @if (configuration.opportunitiesAmount === 1) {
        {{
          'outlook.summary.opportunity.amount'
            | translate
              : {
                  label: 'outlook.entries.opportunity' | translate,
                }
        }}
      } @else {
        {{
          'outlook.summary.opportunity.amount'
            | translate
              : {
                  label: 'outlook.entries.opportunities' | translate,
                }
        }}
      }
    </span>
    <a
      id="outlook-opportunity-ui-summaryOpportunity-more"
      class="underline text-link"
      [href]="deepLink"
      target="_blank"
      rel="noopener"
      >{{ 'outlook.summary.openInMaximizer' | translate }}</a
    >
  </div>
}
